(function () {
    'use strict';

    angular
        .module('elogbooks.common.tasks', []);
})();